import {
    request,
} from './request.js'


// 文章top
export function reqActileList(data) {
    return request({
        url: '/web/back/sys/doc/docCount',
        method: 'get',
		params:data
    })
}

// 文章审核状态  
export function reqState() {
    return request({
        url: '/web/back/sys/doc/isReleaseStatistics',
        method: 'get',
    })
}



// 文章分类统计
export function reqnavigationDoc(data) {
    return request({
        url: '/web/back/sys/navigation/navigationDocStatistics',
        method: 'get',
		params:data
    })
}


// 近一周文章数量统计
export function reqWeekDoc() {
    return request({
        url: '/web/back/sys/doc/weekDocQuantity',
        method: 'get',
    })
}

// 文章统计
export function reqDocList() {
    return request({
        url: '/web/back/sys/navigationDoc/selectDocList',
        method: 'get',
    })
}


//    运维人员审核文章数量

export function reqUserDocList() {
    return request({
        url: '/web/back/sys/navigationDoc/selectUserDocList',
        method: 'get',
    })
}